import { useSyncExternalStore } from 'react';
import {
  BREAKPOINT_FLAGS,
  getBreakpointsStore,
} from '@/shared/libs/get-breakpoints-store';

export { MOBILE_BREAKPOINT } from '@/shared/libs/get-breakpoints-store';

const noopSubscribe = () => () => {};
const getServerSnapshot = () => 0;

export const useBreakpoints = () => {
  const store = typeof window !== 'undefined' ? getBreakpointsStore() : null;

  const mask = useSyncExternalStore(
    store?.subscribe ?? noopSubscribe,
    store?.getSnapshot ?? getServerSnapshot,
    getServerSnapshot
  );

  return {
    isMobile: (mask & BREAKPOINT_FLAGS.isMobile) !== 0,
    isTablet: (mask & BREAKPOINT_FLAGS.isTablet) !== 0,
    isNotMobile: (mask & BREAKPOINT_FLAGS.isNotMobile) !== 0,
    isPortrait: (mask & BREAKPOINT_FLAGS.isPortrait) !== 0,
    isLandscape: (mask & BREAKPOINT_FLAGS.isLandscape) !== 0,
  };
};
